<template>
  <LuJhu lu-jhu-type="DaXaioLuJhu" />
</template>

<script>
import LuJhu from '@/components/desktop/common/trend/LuJhu'
export default {
  name: 'DaXaio',
  components: {
    LuJhu
  }
}
</script>
